<app-reactive-dialog-content [data]="dialogInputData">

  <app-basic-textarea label="Beschreibung"
                      [fieldProperty]="data?.text"
                      [formControl]="getFormControl('text')"
                      [autosizeMaxRows]="10" [autosizeMinRows]="5">
  </app-basic-textarea>
  <app-basic-datepicker label="Datum"
                        [fieldProperty]="data?.date"
                        [formControl]="getFormControl('date')"
  >
  </app-basic-datepicker>
  <div class="button-container-right">
    <button mat-raised-button color="accent" class="button-right-margin" (click)="onDeleteClick()">LÖSCHEN</button>
    <button mat-raised-button color="accent" class="button-right-margin" (click)="onSaveClick()">SPEICHERN</button>
    <button mat-raised-button class="mat-gray-bg" (click)="onCancelClick()">ABBRECHEN</button>
  </div>
</app-reactive-dialog-content>
